import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async loginUser(data) {
    let response = await apiCall("login", data);
    return response;
  },
  async ActivateUserAccount(data) {
    let response = await apiCall("user/password/set", data);
    return response;
  },
  async fetchUserList(data) {
    let response = await apiCall("user/list", data);
    return response;
  },
  async resetUserPassword(data) {
    let response = await apiCall("user/password/reset", data);
    return response;
  },

  async changePassword(data) {
    let response = await apiCall("user/password/change", data);
    return response;
  },

  async getRolePermissionCodes(role_id) {
    let data = {
      role_id: role_id,
    };

    let response = await apiCall("permission/list/role", data);
    return response;
  },
  async fetchUserProfile(data) {
    let response = await apiCall("mobile/webapp/user_info", data);
    return response;
  },
  async fetchSmallRoleList(data) {
    let response = await apiCall("user/roles/two", data);
    return response;
  },
  async remoteLogout(user_id) {
    let data = {
      user_id: user_id,
    };

    let response = await apiCall("user/remote/logout", data);
    return response;
  },
  async deleteUserAccount(account_id) {
    let data = {
      account_id: account_id,
    };

    let response = await apiCall("user/delete", data);
    return response;
  },
  async logoutUser(user_id) {
    let data = {
      user_id: user_id,
    };

    let response = await apiCall("user/remote/logout", data);
    return response;
  },
  async uploadPicture(account_id, profile_pic) {
    let data = {
      account_id: account_id,
      profile_pic: profile_pic
    };

    let response = await apiCall("user/profile_pic/upload", data);
    return response;
  },

  async updateSchool(id, school) {
    let data = {
      id: id,
      school: school
    };

    let response = await apiCall("school_user/update", data);
    return response;
  },

  async updateSchoolOfVendor(id, school_id) {
    let data = {
      id: id,
      school_id: school_id
    };

    let response = await apiCall("vendor/change_school", data);
    return response;
  },

  async updateNames(user_id, first_name, surname) {
    let data = {
      user_id: user_id,
      first_name: first_name,
      surname: surname
    };

    let response = await apiCall("user/update_names", data);
    return response;
  },
  async restrictAccount(account_id) {
    let data = {
      account_id: account_id
    };
    let response = await apiCall("user/disable", data);
    return response;
  },
  async unrestrictAccount(account_id) {
    let data = {
      account_id: account_id
    };
    let response = await apiCall("user/enable", data);
    return response;
  },
  async restrictCalls(account_id) {
    let data = {
      account_id: account_id
    };
    let response = await apiCall("user/disable_calls", data);
    return response;
  },
  async enableCalls(account_id) {
    let data = {
      account_id: account_id
    };
    let response = await apiCall("user/enable_calls", data);
    return response;
  },
  async fetchRecentDashboardActivations(data) {
    let response = await apiCall("user/useractivation/list_recent_dashboard_activations", data);
    return response;
  },
  async fetchRecentSchoolDashboardActivations(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("user/useractivation/list_recent_dashboard_activations", data);
    return response;
  },
  async updateDisbursementNumber(data) {
    let response = await apiCall("mobile/webapp/update_disbursement_number", data);
    return response;
  },
  async remoteLogoutParent(account_id) {
    let data = {
      parent_user_id: account_id
    };
    let response = await apiCall("mobile/webapp/remote_logout_for_parent_app", data);
    return response;
  },

  async processDisbursement(data) {
    let response = await apiCall("mobile/webapp/disburse_vendor_commissions", data);
    return response;
  },
  async loadFloat(data) {
    let response = await apiCall("mobile/webapp/deposit_virtual_float", data);
    return response;
  },
};
